<script setup lang="ts">
    import { onMounted } from 'vue';
    import AppEventStatsRow from '@/pages/core/event/EventStatsRow.vue';
    import { useEventStore } from '@/stores/event';
    import { useTheme } from 'vuetify';

    onMounted(() => {
        console.log('Component %s mounted.', 'app-eventStatsSidePanel');
    });

    const { t } = useI18n();
    const theme = useTheme();
    const eventStore = useEventStore();
</script>

<template>
    <v-card elevation="0" style="border-radius: 8px">
        <v-card-title class="font14 pl-4 pt-1 greyText font-weight-regular">
            <v-icon size="24" :icon="mdiChartBoxOutline" />
            {{ t('eventStats.liveStats') }}
        </v-card-title>
        <v-card-text v-if="eventStore.stats">
            <AppEventStatsRow
                v-if="eventStore.stats.yellowHome !== undefined && eventStore.stats.yellowAway !== undefined && eventStore.stats.yellowHome !== null && eventStore.stats.yellowAway !== null"
                :header-text="t('eventStats.yellowCards')"
                :background-color="theme.name.value === 'dark' ? '#2c2f33' : '#FEF7DC'"
                :filled-color="theme.name.value === 'dark' ? '#E4AC01' : '#FEE8A4'"
                filled-darker-color="#FECA30"
                :value-one="eventStore.stats.yellowHome"
                :value-two="eventStore.stats.yellowAway"
            ></AppEventStatsRow>

            <AppEventStatsRow
                v-if="eventStore.stats.foulsHome !== undefined && eventStore.stats.foulsAway !== undefined && eventStore.stats.foulsHome !== null && eventStore.stats.foulsAway !== null"
                :header-text="t('eventStats.fouls')"
                :background-color="theme.name.value === 'dark' ? '#2c2f33' : '#E8E8E8'"
                :filled-color="theme.name.value === 'dark' ? '#545454' : '#A6A6A6'"
                filled-darker-color="#666666"
                :value-one="eventStore.stats.foulsHome"
                :value-two="eventStore.stats.foulsAway"
                numbers-class="orangeDarkText"
            ></AppEventStatsRow>

            <AppEventStatsRow
                v-if="
                    eventStore.stats.possessionTimeHome !== undefined &&
                    eventStore.stats.possessionTimeAway !== undefined &&
                    eventStore.stats.possessionTimeHome !== null &&
                    eventStore.stats.possessionTimeAway !== null
                "
                :header-text="t('eventStats.possession')"
                :background-color="theme.name.value === 'dark' ? '#2c2f33' : '#EDF5EA'"
                :filled-color="theme.name.value === 'dark' ? '#4D7939' : '#B7D6A8'"
                :filled-darker-color="theme.name.value === 'dark' ? '#6aa84f' : '#6AA84F'"
                :with-percent="true"
                :value-one="eventStore.stats.possessionTimeHome"
                :value-two="eventStore.stats.possessionTimeAway"
            ></AppEventStatsRow>

            <AppEventStatsRow
                v-if="eventStore.stats.attacksHome !== undefined && eventStore.stats.attacksAway !== undefined && eventStore.stats.attacksHome !== null && eventStore.stats.attacksAway !== null"
                :header-text="t('eventStats.attacks')"
                :background-color="theme.name.value === 'dark' ? '#2c2f33' : '#EDF5EA'"
                :filled-color="theme.name.value === 'dark' ? '#4D7939' : '#B7D6A8'"
                :filled-darker-color="theme.name.value === 'dark' ? '#6aa84f' : '#6AA84F'"
                :value-one="eventStore.stats.attacksHome"
                :value-two="eventStore.stats.attacksAway"
            ></AppEventStatsRow>

            <AppEventStatsRow
                v-if="
                    eventStore.stats.dangerousAttacksHome !== undefined &&
                    eventStore.stats.dangerousAttacksAway !== undefined &&
                    eventStore.stats.dangerousAttacksHome !== null &&
                    eventStore.stats.dangerousAttacksAway !== null
                "
                :header-text="t('eventStats.dangerousAttacks')"
                :background-color="theme.name.value === 'dark' ? '#2c2f33' : '#EDF5EA'"
                :filled-color="theme.name.value === 'dark' ? '#4D7939' : '#B7D6A8'"
                :filled-darker-color="theme.name.value === 'dark' ? '#6aa84f' : '#6AA84F'"
                :value-one="eventStore.stats.dangerousAttacksHome"
                :value-two="eventStore.stats.dangerousAttacksAway"
            ></AppEventStatsRow>

            <AppEventStatsRow
                v-if="eventStore.stats.shotsHome !== undefined && eventStore.stats.shotsAway !== undefined && eventStore.stats.shotsHome !== null && eventStore.stats.shotsAway !== null"
                :header-text="t('eventStats.shots')"
                :background-color="theme.name.value === 'dark' ? '#2c2f33' : '#EDF5EA'"
                :filled-color="theme.name.value === 'dark' ? '#4D7939' : '#B7D6A8'"
                :filled-darker-color="theme.name.value === 'dark' ? '#6aa84f' : '#6AA84F'"
                :value-one="eventStore.stats.shotsHome"
                :value-two="eventStore.stats.shotsAway"
            ></AppEventStatsRow>

            <AppEventStatsRow
                v-if="
                    eventStore.stats.shotsOnTargetHome !== undefined &&
                    eventStore.stats.shotsOnTargetAway !== undefined &&
                    eventStore.stats.shotsOnTargetHome !== null &&
                    eventStore.stats.shotsOnTargetAway !== null
                "
                :header-text="t('eventStats.shotsOnTarget')"
                :background-color="theme.name.value === 'dark' ? '#2c2f33' : '#EDF5EA'"
                :filled-color="theme.name.value === 'dark' ? '#4D7939' : '#B7D6A8'"
                :filled-darker-color="theme.name.value === 'dark' ? '#6aa84f' : '#6AA84F'"
                :value-one="eventStore.stats.shotsOnTargetHome"
                :value-two="eventStore.stats.shotsOnTargetAway"
            ></AppEventStatsRow>

            <AppEventStatsRow
                v-if="
                    eventStore.stats.hitWoodworkHome !== undefined &&
                    eventStore.stats.hitWoodworkAway !== undefined &&
                    eventStore.stats.hitWoodworkHome !== null &&
                    eventStore.stats.hitWoodworkAway !== null
                "
                :header-text="t('eventStats.hitWoodwork')"
                :background-color="theme.name.value === 'dark' ? '#2c2f33' : '#EDF5EA'"
                :filled-color="theme.name.value === 'dark' ? '#4D7939' : '#B7D6A8'"
                :filled-darker-color="theme.name.value === 'dark' ? '#6aa84f' : '#6AA84F'"
                :value-one="eventStore.stats.hitWoodworkHome"
                :value-two="eventStore.stats.hitWoodworkAway"
            ></AppEventStatsRow>

            <AppEventStatsRow
                v-if="eventStore.stats.cornersHome !== undefined && eventStore.stats.cornersAway !== undefined && eventStore.stats.cornersHome !== null && eventStore.stats.cornersAway !== null"
                :header-text="t('eventStats.corners')"
                :background-color="theme.name.value === 'dark' ? '#2c2f33' : '#EDF5EA'"
                :filled-color="theme.name.value === 'dark' ? '#4D7939' : '#B7D6A8'"
                :filled-darker-color="theme.name.value === 'dark' ? '#6aa84f' : '#6AA84F'"
                :value-one="eventStore.stats.cornersHome"
                :value-two="eventStore.stats.cornersAway"
            ></AppEventStatsRow>
        </v-card-text>
    </v-card>
</template>

<style scoped></style>
